export default function ReleaseItem(item) {
  return (
    <div>
      {item.cat ? <strong>{item.cat}</strong> : ``}
      <div className={`release-${item.status}`}>
        <p dangerouslySetInnerHTML={{ __html: item.descr }}></p>
      </div>
    </div>
  );
}
